import React, { useEffect, useState, useCallback } from "react";
import { AArrowDown, AArrowUp } from "lucide-react";

/**
 * Wiederverwendbare Schriftgroessen-Steuerung.
 * Synchronisiert ueber localStorage (Key konfigurierbar) und gibt den aktuellen Wert
 * via `onChange(value)` zurueck. Empfehlung: parent setzt das via `style={{ '--news-font-size': value+'px' }}`.
 */
const FontSizeToggle = ({
  storageKey = "habthek-content-font-size",
  initial = 16,
  min = 13,
  max = 22,
  onChange,
  className = "",
  "data-testid": testId = "content-font-size",
}) => {
  const [size, setSize] = useState(() => {
    try {
      const v = parseInt(localStorage.getItem(storageKey) || String(initial), 10);
      return Number.isFinite(v) && v >= min && v <= max ? v : initial;
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try { localStorage.setItem(storageKey, String(size)); } catch { /* ignore */ }
    onChange && onChange(size);
  }, [size, storageKey, onChange]);

  const dec = useCallback(() => setSize((s) => Math.max(min, s - 1)), [min]);
  const inc = useCallback(() => setSize((s) => Math.min(max, s + 1)), [max]);

  return (
    <div className={`flex items-center justify-end gap-2 ${className}`}>
      <span className="text-[10px] uppercase tracking-wider text-zinc-500">Schriftgröße</span>
      <div className="inline-flex items-center gap-0.5 rounded-lg border border-white/10 bg-[#10141b] p-0.5" data-testid={testId}>
        <button
          type="button"
          data-testid={`${testId}-smaller`}
          onClick={dec}
          className="rounded-md px-2 py-1 text-zinc-300 hover:bg-white/10"
          title="Kleiner"
        >
          <AArrowDown className="h-3.5 w-3.5" />
        </button>
        <span className="px-1 text-[11px] tabular-nums text-zinc-500 min-w-[24px] text-center">{size}</span>
        <button
          type="button"
          data-testid={`${testId}-larger`}
          onClick={inc}
          className="rounded-md px-2 py-1 text-zinc-300 hover:bg-white/10"
          title="Größer"
        >
          <AArrowUp className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default FontSizeToggle;
